import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.wallets.KycDetails.Wizard', {
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
});
